<template>
  <div class="alarm-chart-wrap">
    <div :style="setStyle" class="item itemPbx2">
      <div class="alarm-num-header">
        <el-select style="width:120px" v-model="timeType" size="mini">
          <el-option value="day" label="当前告警统计（条）"></el-option>
          <el-option value="month" label="当月告警统计（条）"></el-option>
          <el-option value="year" label="当年告警统计（条）"></el-option>
        </el-select>
        <label class="label-count">
          告警总数：
          <label class="red1">{{ total }}</label> 条
        </label>
      </div>
      <div class="item-chart">
        <div :id="chartBarId" style="width:100%;height:100%;"></div>
      </div>
    </div>
    <div :style="setStyle" class="item1 itemPbx2">
      <div class="item-chart1" style="height: 100%;">
        <div :id="chartAlarmPie" style="width:100%;height:100%;"></div>
        <!-- <div class="dividingLine"></div> -->
      </div>
      <!-- <div class="lines"></div> -->
      <div class="state-txt">状态告警</div>
      <div class="type-txt">类型告警</div>
      <!-- <div class="state-legend">状态:</div>
            <div class="type-legend">类型:</div> -->
    </div>
    <div :style="setStyle" class="item item-top itemPb">
      <div class="item-title" v-if="timeType == 'day'">
        当前告警类型告警排行
      </div>
      <div class="item-title" v-if="timeType == 'month'">
        当月告警类型告警排行
      </div>
      <div class="item-title" v-if="timeType == 'year'">
        当年告警类型告警排行
      </div>
      <div class="item-chart">
        <div :id="chartPieId" style="width:100%;height:100%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import uuidv1 from "uuid/v1";
import { EVEN } from "@/config/data.js";
import * as utils from "@/utils/index.js";
import dateTool from "@/utils/dateTool";
import api from "../../../../../common/api/index";
export default {
  props: ["alarmWrap_h", "typeIndex","typeData"],
  data() {
    return {
      chartBarId: uuidv1(),
      chartPieId: uuidv1(),
      chartAlarmPie: uuidv1(),
      alarmPie: null,
      pieType: null,
      chartBar: null,
      chartPie: null,
      timeType: "day",
      total: 0,
      evenData: EVEN,
      countryColors: ["#00AAFF", "#52CCA3", "#CCCC00", "#e5323e"]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.drawBar(this.chartBarId);
      this.drawPie(this.chartPieId);
      this.getData();
    });
  },
  watch: {
    alarmWrap_h: function(val) {
      this.alarmWrap_h = val;
    },
    timeType(val) {
      this.getData();
    }
  },
  methods: {
    getData() {
      let startTime = "";
      let endTime = "";
      if (this.timeType === "day") {
        startTime = dateTool.format(new Date(), "yyyy-MM-dd") + " 00:00:00";
        endTime = dateTool.format(new Date(), "yyyy-MM-dd hh:mm:ss");
      } else if (this.timeType === "month") {
        startTime = dateTool.format(new Date(), "yyyy-MM") + "/01 00:00:00";
        let end = new Date();
        end.setMonth(end.getMonth() + 1);
        endTime = dateTool.format(end, "yyyy-MM") + "/01 00:00:00";
      } else {
        startTime = dateTool.format(new Date(), "yyyy") + "/01/01 00:00:00";
        let end = new Date();
        end.setFullYear(end.getFullYear() + 1);
        endTime = dateTool.format(end, "yyyy") + "/01/01 00:00:00";
      }
      //根据等级统计告警,根据类型统计告警
      let reqObj = {
        1: "getOverviewThatCountOfEventHandlingForProperty",
        2: "getOverviewThatCountOfEventHandlingForCompanyLessee",
        3: "getCountOfEventStatusGroupByLevelForPersonalLessee"
      };
      if (this.typeIndex == 3) {
        Promise.all([
          api.event.getOverviewThatCountOfEventHandlingForPersonalLessee(
            startTime,
            endTime
          ),
          api.event.getCountOfEventGroupByCodeForPersonalLessee(startTime, endTime),
          api.event.getCountOfEventGroupByTypeForPersonalLessee(startTime, endTime)
        ]).then(resArr => {
          this.setBarData(resArr[0].data);
          this.drawAlarmPie(resArr[0].data, resArr[2].data);
          this.setPieData(resArr[1].data);
        });
      } else {
        Promise.all([
          api.event[reqObj[this.typeIndex]](
            0,
            startTime,
            endTime
          ),
          api.event.getCountOfEventGroupByCodeForProperty(0,startTime, endTime),
          api.event.getCountOfEventGroupByTypeForProperty(0,startTime, endTime)
        ]).then(resArr => {
          this.setBarData(resArr[0].data);
          this.drawAlarmPie(resArr[0].data, resArr[2].data);
          this.setPieData(resArr[1].data);
        });
      }
    },
    drawBar(id) {
      this.chartBar = echarts.init(document.getElementById(id));
      let option = {
        color: ["#00AAFF", "#52CCA3", "#CCCC00", "#e5323e"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          top: 50,
          right: 20,
          bottom: 50
        },
        legend: {
          data: ["告警数", "确认数", "清除数"],
          top: "10",
          textStyle: {
            color: "#999"
          }
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false
            },
            data: [],
            axisLine: {
              lineStyle: {
                color: "#999"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#999"
              }
            }
          }
        ],
        series: [
          {
            name: "告警数",
            type: "bar",
            barGap: 0,
            data: []
          },
          {
            name: "确认数",
            type: "bar",
            data: []
          },
          {
            name: "清除数",
            type: "bar",
            data: []
          }
        ]
      };
      this.chartBar.setOption(option);
    },
    drawPie(id) {
      this.chartPie = echarts.init(document.getElementById(id));
      var option = {
        title: {},
        tooltip: {
          trigger: "axis",
          formatter: (params, ticket, callback) => {
            return (
              params[0].data.name + "<br/>" + "告警数:" + params[0].data.value
            );
          }
        },
        legend: {
          data: []
        },
        grid: {
          x: 120, //左留白
          y: 10, //上留白
          x2: 25, //右留白
          y2: 15 //下留白
        },
        calculable: true,
        dataset: {
          dimensions: ["name", "value"],
          source: []
        },
        xAxis: [
          {
            splitLine: {
              show: false
            },
            type: "value",
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.3)",
                width: 1
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              margin: 100,
              textStyle: {
                align: "left",
                color: "#999", //更改坐标轴文字颜色
                fontSize: 10 //更改坐标轴文字大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              lineStyle: {
                color: "#999",
                width: 1
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: function(value, index) {
                  return "#999";
                },
                fontSize: 12 //更改坐标轴文字大小
              },
              formatter: function(value, index) {
                return value;
              },
              rich: {
                value: {
                  color: "#999",
                  fontSize: 12
                }
              }
            }
          }
        ],
        series: [
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: function(params) {
                  //每根柱子颜色设置
                  let colorList = [
                    ["#E8F8FF", "#E8F8FF"],
                    ["#30BCE0", "#30BCE0"],
                    ["#30BCE0", "#30BCE0"],
                    ["#30BCE0", "#30BCE0"],
                    ["#30BCE0", "#30BCE0"],
                    ["#30BCE0", "#30BCE0"]
                  ];
                  return "#E8F8FFtopcontent";
                }
              }
            }, //柱状图上显示数据
            label: {
              show: "true",
              position: "right",
              color: "#999",
              fontSize: "14"
            }
          }
        ]
      };
      this.chartPie.setOption(option);
    },
    drawAlarmPie(stateData, typeData) {
      //状态告警与类型告警
      let statePieData = this.formatAlarmPieData([stateData], "状态");
      let typePieData = this.formatAlarmPieData(typeData, "类型");
      //处理告警类型图例
      let typeLegend = [];
      typePieData.echartData.forEach(item => {
        typeLegend.push(item.name);
      });

      this.alarmPie = this.$echarts.init(
        document.getElementById(this.chartAlarmPie)
      );
      let str = "占比：";
      let option = {
        tooltip: {
          trigger: "item",
          formatter: `{b} : {c}<br/>${str}{d}%`
        },

        legend: [
          {
            orient: "horizontal",
            top: "5",
            left: "20",
            textStyle: {
              color: "#999"
            },
            data: statePieData.legend
          },

          {
            orient: "horizontal",
            type: "scroll",
            top: "30",
            left: "20",
            textStyle: {
              color: "#999"
            },
            data: typeLegend
          }
        ],

        // color: ['#ff696a','#47d6aa',"#efb64b"],
        color: [
          "#00AAFF",
          "#52CCA3",
          "#CCCC00",
          "#E67A45",
          "#E62E4D",
          "#8673E6",
          "#E673E6",
          "#66CCFF"
        ],
        series: [
          {
            type: "pie",
            name: "",
            radius: ["30%", "58%"],
            center: ["25%", "57%"],
            selectedMode: "single",
            data: statePieData.echartData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            label: {
              show: false
            }
          },
          {
            type: "pie",
            name: "",
            radius: ["30%", "58%"],
            center: ["75%", "57%"],

            selectedMode: "single",
            data: typePieData.echartData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            label: {
              show: false
            }
          }
        ]
      };
      this.alarmPie.setOption(option);
    },
    setBarData(data) {
      let that = this;
      // let total = 0;
      // let xAxisData = [],
      //   totalData = [],
      //   confirmData = [],
      //   handling = [];
      // for (let index = 0; index < data.length; index++) {
      //   const element = data[index];
      //   total += element.total;
      //   totalData.push(element.total);
      //   confirmData.push(element.confirm);
      //   handling.push(element.handled);
      //   xAxisData.push(element.levelName);
      // }
      this.total = data.total;
      this.chartBar.setOption({
        xAxis: {
          data: ["告警数", "确认数", "清除数"]
        },
        series: [
          // {
          //   realtimeSort: true,
          //   name: "X",
          //   type: "bar",
          //   data: data,
          //   label: {
          //     show: true,
          //     position: "right",
          //     valueAnimation: true
          //   }
          // }

          {
            name: "告警数",
            type: "bar",
            data: [data.total, data.confirmed, data.handled],
            itemStyle: {
              color: function(param, index) {
                console.log(param);
                console.log(this);
                return that.countryColors[param.dataIndex] || "#5470c6";
              }
            }
          }

          // {
          //   name: "确认数",
          //   type: "bar",
          //   data: [10]
          // },
          // {
          //   name: "清除数",
          //   type: "bar",
          //   data: [10]
          // }
        ]
      });
    },
    formatAlarmPieData(data, title) {
      //状态与类型告警数据格式化
      if (title == "状态") {
        let xAxisData = [],
          totalData = [],
          confirmData = [],
          handling = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          totalData.push(element.total); //告警总数
          confirmData.push(element.confirm); //告警确认处理数量
          handling.push(element.handling); //处理告警数量
        }
        let echartData = [
          { name: title + "告警数", value: this.sum(totalData) + "" },
          { name: title + "确认数", value: this.sum(confirmData) + "" },
          { name: title + "清除数", value: this.sum(handling) + "" }
        ];
        let legend = [title + "告警数", title + "确认数", title + "清除数"];
        return {
          legend,
          echartData
        };
      } else {
        let echartData = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let typeObj = this.typeData.find(c => c.id == element.type)
          echartData.push({
            name: typeObj ? typeObj.displayName : element.type,
            value: element.total
          });
        }
        return {
          echartData
        };
      }
    },
    sum(arr) {
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        s += arr[i];
      }
      return s;
    },
  setPieData (data = []) {
      let seriesData = [];
      data.sort((a, b) => {
        return b.total - a.total
      })
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        const item = EVEN.find(obj => obj.id == element.code);
        if (item) {
          seriesData.push({ value: element.total, name: item.label });
        }
        if (seriesData.length == 10) {
          break
        }
      }
      this.chartPie.setOption({
        dataset: {
          dimensions: ["name", "value"],
          source: seriesData
        }
      });
    }
  },
  computed: {
    setStyle() {
      let h = (this.alarmWrap_h - 76) / 3;
      return `height:${h}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.alarm-chart-wrap {
  width: 100%;
  height: 100%;
  /*display: grid;*/
  /*grid-template-rows: repeat(3, 1fr);*/
  /*grid-row-gap: 13px;*/
  .item {
    background: #fff;
    border-radius: 4px;
    // overflow: hidden;
    box-sizing: border-box;
    .alarm-num-header {
      background: #63a8eb;
      height: 32px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      box-sizing: border-box;
      align-items: center;
      .label-count {
        .red1 {
          color: #f19085;
          font-weight: bold;
          font-size: 16px;
        }
      }
    }
    .item-chart {
      width: 100%;
      height: 170px;
    }
  }
  .item1 {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    .lines {
      width: 100%;
      height: 1px;
      background: #dfe0e2;
      position: absolute;
      left: 0;
      top: 57px;
      z-index: 19950707;
    }
    .state-txt {
      color: #4d4d4d;
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      bottom: 10px;
      left: 0;
      width: 50%;
      text-align: center;
    }
    .type-txt {
      color: #4d4d4d;
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      bottom: 10px;
      left: 55%;
      width: 40%;
      text-align: center;
    }
    .state-legend {
      position: absolute;
      left: 10px;
      top: 0;
      color: #4d4d4d;
      font-size: 14px;
      line-height: 28px;
    }
    .type-legend {
      position: absolute;
      left: 10px;
      top: 28px;
      color: #4d4d4d;
      font-size: 14px;
      line-height: 28px;
    }
  }
  .item-top {
    padding-bottom: 0px;
  }
  .item-title {
    background: #63a8eb;
    height: 32px;
    padding: 0 10px;
    box-sizing: border-box;
    text-align: left;
    line-height: 32px;
    font-size: 14px;
    font-weight: bold;
    .label-count {
      flex: 1;
      text-align: right;
    }
  }
}
.theme-dark {
  .alarm-chart-wrap .item .alarm-num-header {
    background: #212b46;
  }
  .alarm-chart-wrap .item-title {
    background: #212b46;
  }
  .item-chart,
  .item-chart1 {
    background: #030a1d;
    position: relative;
    height: 100%;
  }
}
.dividingLine {
  position: absolute;
  left: 0px;
  top: 58px;
  height: 1px;
  width: 100%;
  background: #dfdfdf;
}
.itemPbx2 {
  margin-bottom: 30px;
}
</style>
